import React, { Suspense, lazy } from "react";
import { createBrowserRouter } from "react-router-dom";
// import CenteredSpin from "../pages/loader";
import Loading from "../pages/loading";

// 懒加载页面
const JiaQiHome = lazy(() => import("../pages/jia-qi"));
const JiaQiIntro = lazy(() => import("../pages/jia-qi/components/intro"));
const JiaQiUndergraduates = lazy(() => import("../pages/jia-qi/components/undergraduates"));
const JiaQiPostgraduates = lazy(() => import("../pages/jia-qi/components/postgraduates"));
const Project1 = lazy(() => import("../pages/jia-qi/components/postgraduates/projects/1"));
const Project2 = lazy(() => import("../pages/jia-qi/components/postgraduates/projects/2"));
const Project3 = lazy(() => import("../pages/jia-qi/components/postgraduates/projects/3"));
const Project4 = lazy(() => import("../pages/jia-qi/components/postgraduates/projects/4"));
const Project5 = lazy(() => import("../pages/jia-qi/components/postgraduates/projects/5"));
const Workshop = lazy(() => import("../pages/jia-qi/components/postgraduates/workshop"));
const DIEP = lazy(() => import("../pages/jia-qi/components/postgraduates/diep"));
const UProject1 = lazy(() => import("../pages/jia-qi/components/undergraduates/projects/1"));
const UProject2 = lazy(() => import("../pages/jia-qi/components/undergraduates/projects/2"));
const UProject3 = lazy(() => import("../pages/jia-qi/components/undergraduates/projects/3"));
const UProject4 = lazy(() => import("../pages/jia-qi/components/undergraduates/projects/4"));

const Home = lazy(() => import('../pages/home'));
// const Detail = lazy(() => import('../pages/detail'));
const CityIntroDetail = lazy(() => import(/* webpackChunkName: "city-intro-detail", webpackPrefetch: true */ "../pages/city-intro-detail"));
const HistoryIntroDetail = lazy(() => import(/* webpackChunkName: "history-intro-detail", webpackPrefetch: true */ "../pages/history-intro-detail"));
const NotFound = lazy(() => import('../pages/notfound'));
const CityIntro = lazy(() => import('../pages/city-intro'));
const HistoryIntro = lazy(() => import('../pages/history-intro'));

// 通用加载中组件
const Loader = <Loading className="w-screen h-screen flex justify-center items-center flex-col loading" />;

const routeList = [
  {
    path: "/",
    element: (
      <Suspense fallback={Loader}>
        <Home />
      </Suspense>
    ),
  },
  {
    path: "/jiaqi",
    element: (
      <Suspense fallback={Loader}>
        <JiaQiHome />
      </Suspense>
    ),
  },
  {
    path: "/jiaqi/intro",
    element: (
      <Suspense fallback={Loader}>
        <JiaQiIntro />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/undergraduates",
    element: (
      <Suspense fallback={Loader}>
        <JiaQiUndergraduates />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates",
    element: (
      <Suspense fallback={Loader}>
        <JiaQiPostgraduates />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project1",
    element: (
      <Suspense fallback={Loader}>
        <Project1 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project2",
    element: (
      <Suspense fallback={Loader}>
        <Project2 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project3",
    element: (
      <Suspense fallback={Loader}>
        <Project3 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project4",
    element: (
      <Suspense fallback={Loader}>
        <Project4 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project5",
    element: (
      <Suspense fallback={Loader}>
        <Workshop />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project6",
    element: (
      <Suspense fallback={Loader}>
        <DIEP />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/postgraduates/project7",
    element: (
      <Suspense fallback={Loader}>
        <Project5 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/undergraduates/project1",
    element: (
      <Suspense fallback={Loader}>
        <UProject1 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/undergraduates/project2",
    element: (
      <Suspense fallback={Loader}>
        <UProject2 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/undergraduates/project3",
    element: (
      <Suspense fallback={Loader}>
        <UProject3 />
      </Suspense>
    )
  },
  {
    path: "/jiaqi/undergraduates/project4",
    element: (
      <Suspense fallback={Loader}>
        <UProject4 />
      </Suspense>
    )
  },
  {
    path: "city-intro",
    element: (
      <Suspense fallback={Loader}>
        <CityIntro />
      </Suspense>
    )
  },
  {
    path: "history-intro",
    element: (
      <Suspense fallback={Loader}>
        <HistoryIntro />
      </Suspense>
    )
  },
  {
    path: "/city/detail/:provinceCode/:cityName",
    element: (
      <Suspense fallback={Loader}>
        <CityIntroDetail />
      </Suspense>
    ),
  },
  {
    path: "/history/detail/:historyName",
    element: (
      <Suspense fallback={Loader}>
        <HistoryIntroDetail />
      </Suspense>
    ),
  },
  {
    path: "*",
    element: (
      <Suspense fallback={Loader}>
        <NotFound />
      </Suspense>
    ),
  },
];

export const routes = createBrowserRouter(routeList);